import { Tabs } from '@sede-enterprise/shell-ds-react-framework'
import React, { useContext, useState } from 'react'
import { UnitContext } from '../../../App';
import CRChart from './CRChart';
import WTChart from './WTChart';
import Scores from './Scores';


const ResultChart = ({ id, start, end, list, modelId, modelStatus }) => {

    const { units } = useContext(UnitContext)

    const [currTab, setCurrTab] = useState('cr')

    return (
        <div className='model-results-chart'>
            <Tabs tabBarStyle={{
                justifyContent: 'flex-start',
                borderBottom: '1px solid #E0E0E0',
                marginBottom: '20px',
                height: "100%",
            }}
                defaultActiveKey='cr'
                onTabClick={(tab) => setCurrTab(tab)}
                items={[
                    {
                        label: 'Corrosion Rate',
                        key: 'cr',
                        children: <CRChart id={id} start={start} end={end} list={list} modelId={modelId} modelStatus={modelStatus} units={units} currTab={currTab} />
                    },
                    {
                        label: 'Wall Thickness',
                        key: 'wt',
                        children: <WTChart id={id} start={start} end={end} list={list} modelId={modelId} modelStatus={modelStatus} units={units} currTab={currTab} />
                    },
                    ...(modelStatus === "OBSERVATION" ? [{
                        label: 'Scores',
                        key: 'scores',
                        children: <Scores id={id} start={start} end={end} list={list} modelId={modelId} modelStatus={modelStatus} units={units} currTab={currTab} />
                    }] : [])
                ]}
            />

        </div>
    )
}

export default ResultChart